export type Point2D = {
  x: number;
  y: number;
};

type PositionCalculationParams = {
  zoom: number;
  pan: Point2D;
  dimensions: { width: number; height: number };
  zoomCenter?: Point2D | undefined;
};

type Centers = {
  contentCenterX: number;
  contentCenterY: number;
  viewportCenterX: number;
  viewportCenterY: number;
};

export function calculateCenters(
  dimensions: { width: number; height: number },
  zoomCenter?: Point2D | undefined
): Centers {
  const contentCenterX = zoomCenter?.x ?? dimensions.width / 2;
  const contentCenterY = zoomCenter?.y ?? dimensions.height / 2;
  const viewportCenterX = dimensions.width / 2;
  const viewportCenterY = dimensions.height / 2;

  return {
    contentCenterX,
    contentCenterY,
    viewportCenterX,
    viewportCenterY
  };
}

export function calculateStagePosition({
  zoom,
  pan,
  dimensions,
  zoomCenter
}: PositionCalculationParams): Point2D {
  const { contentCenterX, contentCenterY, viewportCenterX, viewportCenterY } = calculateCenters(
    dimensions,
    zoomCenter
  );

  const x = viewportCenterX - contentCenterX * zoom + pan.x;
  const y = viewportCenterY - contentCenterY * zoom + pan.y;

  return { x, y };
}

type ExtractPanParams = {
  stagePosition: Point2D;
  zoom: number;
  dimensions: { width: number; height: number };
  zoomCenter?: Point2D | undefined;
};

export function extractPanFromPosition({
  stagePosition,
  zoom,
  dimensions,
  zoomCenter
}: ExtractPanParams): Point2D {
  const { contentCenterX, contentCenterY, viewportCenterX, viewportCenterY } = calculateCenters(
    dimensions,
    zoomCenter
  );

  const baseX = viewportCenterX - contentCenterX * zoom;
  const baseY = viewportCenterY - contentCenterY * zoom;

  const panX = stagePosition.x - baseX;
  const panY = stagePosition.y - baseY;

  return { x: panX, y: panY };
}
